<div>
  <div class="c-avatar_img bg">
      <em class="material-icons avatar notranslate" aria-hidden="true">
          account_circle
      </em>
    </div>
    <div class="c-avatar_info color-white">
      <p class="font-20">Bienvenido</p>
     <!--  <a class="u-regular color-white font-14 btn-focus-hover c-dropdown-item" #menuContrasena aria-expanded="false"-->
      <!--   id="activate-info-user" href="javascript:" (click)="clickToggle($event)">-->
        <p>{{ userloggedin.firstName.toLowerCase() }} {{ userloggedin.lastName.toLowerCase() }} /
          <span *ngIf="companyData === null">
            <span *ngIf="$companyData | async as dataCompany">{{ dataCompany.nombre.toLowerCase() }}</span>
          </span>

          <span *ngIf="companyData !== null">
            <span >{{ companyData.nombre.toLowerCase() }}</span>
          </span>
          <em aria-hidden="true" class="material-icons">expand_more</em></p>
          <!--<app-sample-material-icon [iconName]="'expand_more'"></app-sample-material-icon>-->
     <!--    </a>-->

    </div>
</div>
<!-- </div> -->

<div class="c-dropdown shadow-item animated fadeInDown" #dropAvatar [ngClass]="{ 'c-dropdown--active': dropActive }">
<!-- <a class="c-dropdown-item" [routerLink]="['/perfil']">
  Ver perfil <i class="material-icons">keyboard_arrow_right</i>
</a> -->
<a (blur)="hiddeToggle()"
appDebounceClick  id="Header_PTEC-Informacion Empresa NavBar" title="Cambiar contraseña"
class="c-dropdown-item" [routerLink]="'/'+change">
  Cambiar contraseña <em class="material-icons" aria-hidden="true">keyboard_arrow_right</em>
</a>
</div>
